<div class="d-flex justify-content-center">
  <button  [matMenuTriggerFor]="menu" class="menu-btn">
    <svg-icon src="assets/icons/menu-icon.svg"></svg-icon>
  </button>
  <mat-menu #menu="matMenu"  class="custom-menu" >
    <div *ngFor="let menu of menuAddress; index as i ">

      @switch (menu.id) {
        @case (3) {
          <button mat-menu-item class="custom-menu-item" *ngIf="data.isvisible" (click)="menuClick(menu.id)"
                  [ngClass]="i+1 == menuAddress.length ? 'border-0' :''" >
            <div class="d-flex align-items-center gap-2" >
              <svg-icon src="assets/icons/{{menu.icon}}"></svg-icon>
              <div class="fs-14 ">{{ menu.label }}</div>
            </div>
          </button>
        }
        @case (4) {
          <button mat-menu-item class="custom-menu-item" *ngIf="!data.isvisible" (click)="menuClick(menu.id)"
                  [ngClass]="i+1 == menuAddress.length ? 'border-0' :''" >
            <div class="d-flex align-items-center gap-2" >
              <svg-icon src="assets/icons/{{menu.icon}}"></svg-icon>
              <div class="fs-14 ">{{ menu.label }}</div>
            </div>
          </button>
        }
        @default {
          <button mat-menu-item class="custom-menu-item"  (click)="menuClick(menu.id)"
                  [ngClass]="i+1 == menuAddress.length ? 'border-0' :''" >
            <div class="d-flex align-items-center gap-2" >
              <svg-icon src="assets/icons/{{menu.icon}}"></svg-icon>
              <div class="fs-14 ">{{ menu.label }}</div>
            </div>
          </button>
        }
      }

    </div>
  </mat-menu>
</div>
